import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { class: "row no-wrap items-start deps-header-row" }
const _hoisted_3 = { class: "deps-header-title" }
const _hoisted_4 = {
  key: 4,
  class: "simple-selector__empty-sub"
}
const _hoisted_5 = {
  key: 5,
  class: "text-center q-my-md"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center q-my-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_parameter_inline_display = _resolveComponent("parameter-inline-display")!
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_counterparty_row = _resolveComponent("counterparty-row")!
  const _component_simple_element = _resolveComponent("simple-element")!
  const _component_variable_list = _resolveComponent("variable-list")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_q_infinite_scroll = _resolveComponent("q-infinite-scroll")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, {
    ref: "scrollTargetRef",
    style: _normalizeStyle(
      _ctx.mHeight
        ? `max-height: ${_ctx.mHeight}px; width: 100%; overflow-y: auto; overflow-x: hidden;`
        : _ctx.mHeight > -1
        ? 'max-height: 45vh;  width: 100%; overflow-y: auto; overflow-x: hidden;'
        : 'height: calc(100% - 30px); width: 100%; overflow-y: auto; overflow-x: hidden;'
    ),
    class: "scroll"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_infinite_scroll, {
        ref: "infscr",
        debounce: 100,
        onLoad: _ctx.loadData,
        offset: 250,
        "scroll-target": _ctx.scrollTargetRef
      }, {
        loading: _withCtx(() => [
          (_ctx.load_offset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (!_ctx.last_load_empty && _ctx.loading)
                  ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_ctx.showSelectAll && _ctx.allowMultiple && (_ctx.hasDeps || !_ctx.hideCheckboxes) && (!_ctx.hasDeps || _ctx.visibleDeps.length))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["row no-wrap items-start deps-select-all-row", { 'deps-select-all-row--deps': _ctx.hasDeps, 'select-all-row--storages': _ctx.isStoragesMode }])
              }, [
                (!_ctx.hideCheckboxes)
                  ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                      key: 0,
                      class: _normalizeClass(['rec-checkbox', { 'q-mx-xs': !_ctx.hasDeps && !_ctx.isStoragesMode, 'select-all-check--storages': _ctx.isStoragesMode }]),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                      "model-value": _ctx.getSelectedAll,
                      "onUpdate:modelValue": _ctx.setSelectedAll
                    }, null, 8, ["class", "model-value", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(['deps-select-all-label', { 'select-all-label--storages': _ctx.isStoragesMode }])
                }, _toDisplayString(_ctx.$t("all")), 3)
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.hasDeps)
            ? (_openBlock(), _createBlock(_component_variable_list, {
                key: 1,
                "is-table": _ctx.isTableView,
                ref: "simple_selector_list",
                class: "q-px-xs",
                elements: _ctx.data_list,
                modelValue: _ctx.listModelData,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listModelData) = $event)),
                "allow-multiple": _ctx.allowMultiple,
                "allow-wrap": true,
                "slot-wrap-display-contents": _ctx.isTableView,
                "is-item-disabled": _ctx.storageItemIsDisabled,
                onItemSelected: _ctx.onItemSelected,
                viewport: _ctx.$refs.scrollTargetRef,
                "show-checkbox": _ctx.allowMultiple && !_ctx.hideCheckboxes,
                onEmptyClick: _ctx.onEmptyClick
              }, {
                default: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, "item", {
                    item: slotProps.item
                  }, () => [
                    (_ctx.elementType === _ctx.VariableType.ParameterInline)
                      ? (_openBlock(), _createBlock(_component_parameter_inline_display, {
                          key: 0,
                          id: "ds",
                          editable: false,
                          "is-table": true,
                          "model-value": _ctx.getPositionNameModel(slotProps.item)
                        }, null, 8, ["model-value"]))
                      : (_ctx.elementType === _ctx.VariableType.Bill)
                        ? (_openBlock(), _createBlock(_component_bill_row, {
                            key: 1,
                            el: slotProps.item.bill,
                            "bill-type": slotProps.item.billRowType
                          }, null, 8, ["el", "bill-type"]))
                        : (_ctx.elementType === _ctx.VariableType.Counterparty)
                          ? (_openBlock(), _createBlock(_component_counterparty_row, {
                              key: 2,
                              el: slotProps.item
                            }, null, 8, ["el"]))
                          : (_openBlock(), _createBlock(_component_simple_element, {
                              key: 3,
                              element: slotProps.item,
                              elementType: _ctx.elementType,
                              filter_string: _ctx.objectFilter ? _ctx.filter_value.stringFilter : _ctx.filter_value
                            }, null, 8, ["element", "elementType", "filter_string"]))
                  ], true)
                ]),
                _: 3
              }, 8, ["is-table", "elements", "modelValue", "allow-multiple", "slot-wrap-display-contents", "is-item-disabled", "onItemSelected", "viewport", "show-checkbox", "onEmptyClick"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleDeps, (dep, d_index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: dep.department + '_' + d_index,
                    class: "deps-block"
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      (!_ctx.hideCheckboxes)
                        ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                            key: 0,
                            class: "rec-checkbox deps-header-check",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                            "model-value": _ctx.getSelectedDepModel(d_index),
                            "onUpdate:modelValue": ($event: any) => (_ctx.setSelectedDepModel(d_index))
                          }, null, 8, ["model-value", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDepTitleSpans(dep.department), (span, idx) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: `${dep.department}_${idx}`,
                            style: _normalizeStyle(span.style)
                          }, _toDisplayString(span.text), 5))
                        }), 128))
                      ])
                    ]),
                    _createVNode(_component_variable_list, {
                      class: _normalizeClass(['deps-children-list', { 'deps-children-list--full': _ctx.full }]),
                      ref_for: true,
                      ref: (el) => { _ctx.divs[d_index] = el; },
                      elements: dep.child,
                      columns: _ctx.full ? 2 : 1,
                      modelValue: _ctx.listModelData,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listModelData) = $event)),
                      "allow-multiple": _ctx.allowMultiple,
                      "allow-wrap": true,
                      onItemSelected: _ctx.onItemSelected,
                      viewport: _ctx.$refs.scrollTargetRef,
                      "show-checkbox": _ctx.hasDeps && !_ctx.hideCheckboxes,
                      onEmptyClick: _ctx.onEmptyClick
                    }, {
                      default: _withCtx((slotProps) => [
                        _renderSlot(_ctx.$slots, "item", {
                          item: slotProps.item
                        }, () => [
                          (_ctx.elementType === _ctx.VariableType.ParameterInline)
                            ? (_openBlock(), _createBlock(_component_parameter_inline_display, {
                                key: 0,
                                id: "ds",
                                editable: false,
                                "is-table": true,
                                "model-value": _ctx.getPositionNameModel(slotProps.item)
                              }, null, 8, ["model-value"]))
                            : (_ctx.elementType === _ctx.VariableType.Bill)
                              ? (_openBlock(), _createBlock(_component_bill_row, {
                                  key: 1,
                                  el: slotProps.item.bill,
                                  "bill-type": slotProps.item.billRowType
                                }, null, 8, ["el", "bill-type"]))
                              : (_ctx.elementType === _ctx.VariableType.Counterparty)
                                ? (_openBlock(), _createBlock(_component_counterparty_row, {
                                    key: 2,
                                    el: slotProps.item
                                  }, null, 8, ["el"]))
                                : (_openBlock(), _createBlock(_component_simple_element, {
                                    key: 3,
                                    element: slotProps.item,
                                    elementType: _ctx.elementType,
                                    filter_string: _ctx.objectFilter ? _ctx.filter_value.stringFilter : _ctx.filter_value
                                  }, null, 8, ["element", "elementType", "filter_string"]))
                        ], true)
                      ]),
                      _: 2
                    }, 1032, ["class", "elements", "columns", "modelValue", "allow-multiple", "onItemSelected", "viewport", "show-checkbox", "onEmptyClick"])
                  ]))
                }), 128))
              ])),
          (!_ctx.loading && !_ctx.displayedDataLength && _ctx.load_offset)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["simple-selector__empty", { 'simple-selector__empty--hint': _ctx.showCreateHint }])
              }, _toDisplayString(_ctx.emptyText), 3))
            : _createCommentVNode("", true),
          (!_ctx.loading && !_ctx.displayedDataLength && _ctx.load_offset && _ctx.hasFilterText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.noMatchesSubText), 1))
            : _createCommentVNode("", true),
          (!_ctx.load_offset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!_ctx.last_load_empty && _ctx.loading)
                  ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["onLoad", "scroll-target"])
    ]),
    _: 3
  }, 8, ["style"]))
}